var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.show_hide.billing_details ? _c('div', {
    staticClass: "billing_invoice_new dashboard-card dashboard-card-lt mt-4"
  }, [_c('div', {
    staticClass: "billing_invoice_new-title d-flex"
  }, [_c('div', [_c('h3', [_vm._v("Billing & Invoices")]), _c('div', {
    staticClass: "policy_id_selector"
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.options
    },
    on: {
      "change": _vm.getByPolicyID
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Select System ID")])];
      },
      proxy: true
    }], null, false, 506542558),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)]), _c('payment-history-download')], 1), _c('div', {
    staticClass: "billing_invoice_new_table_wrap"
  }, [_c('div', {
    staticClass: "billing_invoice_new_table_inner"
  }, [_c('div', {
    staticClass: "table_content"
  }, [_vm.skeletonLoader ? _c('b-skeleton-table', {
    attrs: {
      "rows": 4,
      "columns": 4,
      "table-props": {
        bordered: true,
        striped: true
      }
    }
  }) : _vm._e(), _vm.skeletonLoader == false ? _c('table', [_vm._m(0), _vm._l(_vm.billing_invoice, function (item, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', {
      class: item.invoice_details.invoice_status == 'UNPAID' ? 'unpaid' : 'paid'
    }, [_c('td', [_c('span', [_vm._v(" " + _vm._s(item.invoice_details.invoice_id) + " ")]), _c('span', [_vm._v(" " + _vm._s("System ID: " + item.invoice_details.invoice_policy_id) + " ")]), _c('span', [_vm._v(" " + _vm._s(item.invoice_details.term_status ? item.invoice_details.term_status + " [" + item.invoice_details.term_date + "]" : "") + " ")])]), _c('td', [_c('span', [_vm._v(" " + _vm._s("Invoice Date: " + item.invoice_details.invoice_date))]), _c('span', [_vm._v(" " + _vm._s("Invoice Due Date: " + item.invoice_details.invoice_due_date))]), _c('span', [_vm._v(" Service Date: ")]), _c('span', [_vm._v(_vm._s(item.invoice_details.invoice_start_date + " - " + item.invoice_details.invoice_end_date))])]), _c('td', [item.invoice_details.efee != '$0.00' ? _c('span', [_vm._v(" " + _vm._s("Efees Amount: " + item.invoice_details.efee))]) : _vm._e(), item.invoice_details.late_fee != '$0.00' ? _c('span', [_vm._v(" " + _vm._s("Late Fee Amount: " + item.invoice_details.late_fee))]) : _vm._e(), item.invoice_details.bounce_fee != '$0.00' ? _c('span', [_vm._v(" " + _vm._s("Bounce Fee Amount: " + item.invoice_details.bounce_fee))]) : _vm._e(), item.invoice_details.statement_fee != '$0.00' ? _c('span', [_vm._v(" " + _vm._s("Statement Fee Amount: " + item.invoice_details.statement_fee))]) : _vm._e(), item.invoice_details.policy_amount != '$0.00' ? _c('span', [_vm._v(" " + _vm._s("Policy Amount: " + item.invoice_details.policy_amount))]) : _vm._e(), item.invoice_details.previous_due != '$0.00' ? _c('span', [_vm._v(" " + _vm._s("Previous Due Amount: " + item.invoice_details.previous_due))]) : _vm._e(), item.invoice_details.overall_amount != '$0.00' ? _c('span', [_vm._v(" " + _vm._s("Overall Amount: " + item.invoice_details.overall_amount))]) : _vm._e(), item.invoice_details.paid_amount != '$0.00' ? _c('span', [_vm._v(" " + _vm._s("Paid Amount: " + item.invoice_details.paid_amount))]) : _vm._e(), item.invoice_details.processing_amount != '$0.00' ? _c('span', [_vm._v(" " + _vm._s("Processing Amount: " + item.invoice_details.processing_amount))]) : _vm._e(), _c('span', {
      staticStyle: {
        "border-top": "2px dotted grey",
        "width": "80%"
      }
    }), _c('span', [_vm._v(_vm._s("Overall Due Amount :" + item.invoice_details.overall_due_amount) + " ")])]), _c('td', [_c('strong', [_vm._v(_vm._s(item.invoice_details.invoice_status))])]), _c('td', _vm._l(item.billing_details, function (billingData, billingIndex) {
      return _c('div', {
        key: billingIndex
      }, [_c('span', [_vm._v(_vm._s("Payment Date: " + billingData.payment_date) + " ")]), _c('span', [_vm._v("Estimated Clearing Date: " + _vm._s(billingData.estimated_clearing_date ? billingData.estimated_clearing_date.split('-')[1] + '/' + billingData.estimated_clearing_date.split('-')[2] + '/' + billingData.estimated_clearing_date.split('-')[0] : 'N/A') + " ")]), _c('span', [_vm._v("Actual Clearing Date: " + _vm._s(billingData.actual_clearing_date ? billingData.actual_clearing_date.split('-')[1] + '/' + billingData.actual_clearing_date.split('-')[2] + '/' + billingData.actual_clearing_date.split('-')[0] : 'N/A') + " ")]), _c('span', [_vm._v(_vm._s("Payment Method: " + billingData.method) + " ")]), _c('span', [_vm._v("Payment Status:"), _c('strong', [_vm._v(" " + _vm._s(billingData.payment_status))])]), _c('span', [_vm._v(_vm._s("Payment Type: " + billingData.payment_type) + " ")]), _vm._l(billingData.additional_data, function (additionalData, additionalIndex) {
        return _c('span', {
          key: additionalIndex
        }, [_vm._v(" " + _vm._s(additionalData.key + ": ") + " " + _vm._s(additionalData.value) + " ")]);
      }), billingIndex + 1 != item.billing_details.length ? _c('span', {
        staticStyle: {
          "border-top": "2px dotted black",
          "width": "76%"
        }
      }) : _vm._e()], 2);
    }), 0), _c('td', {
      staticClass: "pay"
    }, [_c('span', {
      staticClass: "pay-btn"
    }, [item.invoice_details.pay_now ? _c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.paymentDailog",
        modifiers: {
          "paymentDailog": true
        }
      }],
      on: {
        "click": function ($event) {
          return _vm.payNow(item.invoice_details.invoice_id);
        }
      }
    }, [_vm._v(" Pay Now ")]) : _vm._e()]), _c('span', {
      staticClass: "download-btn"
    }, [item.invoice_details.file_link != '' ? _c('button', {
      on: {
        "click": function ($event) {
          return _vm.downloadFile(item.invoice_details.file_link);
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 482.14 482.14"
      },
      attrs: {
        "version": "1.1",
        "id": "Capa_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 482.14 482.14",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('path', {
      attrs: {
        "d": "M142.024,310.194c0-8.007-5.556-12.782-15.359-12.782c-4.003,0-6.714,0.395-8.132,0.773v25.69\n                        c1.679,0.378,3.743,0.504,6.588,0.504C135.57,324.379,142.024,319.1,142.024,310.194z"
      }
    }), _c('path', {
      attrs: {
        "d": "M202.709,297.681c-4.39,0-7.227,0.379-8.905,0.772v56.896c1.679,0.394,4.39,0.394,6.841,0.394\n                        c17.809,0.126,29.424-9.677,29.424-30.449C230.195,307.231,219.611,297.681,202.709,297.681z"
      }
    }), _c('path', {
      attrs: {
        "d": "M315.458,0H121.811c-28.29,0-51.315,23.041-51.315,51.315v189.754h-5.012c-11.418,0-20.678,9.251-20.678,20.679v125.404\n                        c0,11.427,9.259,20.677,20.678,20.677h5.012v22.995c0,28.305,23.025,51.315,51.315,51.315h264.223\n                        c28.272,0,51.3-23.011,51.3-51.315V121.449L315.458,0z M99.053,284.379c6.06-1.024,14.578-1.796,26.579-1.796\n                        c12.128,0,20.772,2.315,26.58,6.965c5.548,4.382,9.292,11.615,9.292,20.127c0,8.51-2.837,15.745-7.999,20.646\n                        c-6.714,6.32-16.643,9.157-28.258,9.157c-2.585,0-4.902-0.128-6.714-0.379v31.096H99.053V284.379z M386.034,450.713H121.811\n                        c-10.954,0-19.874-8.92-19.874-19.889v-22.995h246.31c11.42,0,20.679-9.25,20.679-20.677V261.748\n                        c0-11.428-9.259-20.679-20.679-20.679h-246.31V51.315c0-10.938,8.921-19.858,19.874-19.858l181.89-0.19v67.233\n                        c0,19.638,15.934,35.587,35.587,35.587l65.862-0.189l0.741,296.925C405.891,441.793,396.987,450.713,386.034,450.713z\n                        M174.065,369.801v-85.422c7.225-1.15,16.642-1.796,26.58-1.796c16.516,0,27.226,2.963,35.618,9.282\n                        c9.031,6.714,14.704,17.416,14.704,32.781c0,16.643-6.06,28.133-14.453,35.224c-9.157,7.612-23.096,11.222-40.125,11.222\n                        C186.191,371.092,178.966,370.446,174.065,369.801z M314.892,319.226v15.996h-31.23v34.973h-19.74v-86.966h53.16v16.122h-33.42\n                        v19.875H314.892z"
      }
    })]), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g')]), _vm._v(" Download ")]) : _vm._e()]), item.invoice_details.invoice_status == 'PAID' && item.invoice_details.paystand_id ? _c('span', {
      staticClass: "pay-receipt-btn"
    }, [_c('button', {
      on: {
        "click": function ($event) {
          return _vm.routeToPaymentDownload(item.invoice_details.paystand_id);
        }
      }
    }, [_vm._v(" Payment Receipt ")])]) : _vm._e()])])]);
  })], 2) : _vm._e()], 1)])]), _c('div', {
    staticClass: "pagination-controls"
  }, [_c('div', {
    staticClass: "css-controls"
  }, [_c('div', {
    staticClass: "rows-per-page"
  }, [_c('label', {
    attrs: {
      "for": "row-per-page-select"
    }
  }, [_vm._v("Rows per page:")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pagination.perPage,
      expression: "pagination.perPage"
    }],
    attrs: {
      "id": "rows-per-page-select"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.pagination, "perPage", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        return _vm.changePage(1);
      }]
    }
  }, _vm._l(_vm.pageSizes, function (size) {
    return _c('option', {
      key: size,
      domProps: {
        "value": size
      }
    }, [_vm._v(_vm._s(size))]);
  }), 0)]), _c('div', {
    staticClass: "showing-entries"
  }, [_vm._v(" Showing " + _vm._s(_vm.from) + " to " + _vm._s(_vm.to) + " of " + _vm._s(_vm.pagination.total) + " results ")])]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.pagination.total,
      "first-text": "First",
      "prev-text": "Prev",
      "next-text": "Next",
      "last-text": "Last",
      "per-page": _vm.pagination.perPage,
      "page-click": _vm.changePage,
      "bvEvent": _vm.changePage
    },
    on: {
      "change": _vm.changePage
    },
    model: {
      value: _vm.pagination.current,
      callback: function ($$v) {
        _vm.$set(_vm.pagination, "current", $$v);
      },
      expression: "pagination.current"
    }
  })], 1)]), _c('b-modal', {
    attrs: {
      "id": "paymentDailog",
      "centered": true,
      "title": "Payment",
      "hide-footer": true,
      "size": "md",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": function ($event) {
        return _vm.paymentMade();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.paymentUrl,
      "allowfullscreen": ""
    }
  })])])])], 1) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('td', [_vm._v("Invoice")]), _c('td', [_vm._v("Date/Term")]), _c('td', [_vm._v("Totals")]), _c('td', [_vm._v("Status")]), _c('td', [_vm._v("Payments")]), _c('td', [_vm._v("Action")])])]);

}]

export { render, staticRenderFns }